<template>
	<div style="width: 100%;height: 100%;">
		<!-- 不用 inset 简写，低版本 WebView(Chromium < 87) 不支持 -->
		<div style="background: #000;opacity: 0.6;position: fixed;top: 0;right: 0;bottom: 0;left: 0;"></div>
		<div class="popupBox">
			<!-- 版本号显示 -->
			<div class="versionInfo">v{{ appVersion }}</div>
			<!-- 安卓2是横屏，ios1是横屏 -->
			<div class="popupCon" :class="{'lans':(!isios && ostype == 2) || (isios && ostype == 1)}" v-if="isOpenPlat">
				<h2 class="gmTitle">GM权限工具</h2>
				<div class="gmList subConbg">
					<h4 class="subTitle">
						购买权限
						<a style="display: inline-block;" @touchstart.prevent="showRules = true">
							<el-icon size="20"><Warning /></el-icon>
						</a>
					</h4>
					<div class="listCon" ref="scrollList" @scroll="handleScroll">
						<ul>
							<li v-for="(item,index) in goodsList" :key="index">
								<div class="listItem" :class="{'active':item.id == activePropInfo.id}" @touchstart.prevent="handlePropInfo(item)">
									<div class="titles">
										<p class="title">{{ item.title }}</p>
										<!-- 是否购买1是0否 -->
										<p class="green" v-if="item.buy==1">已开通</p>
										<p class="red" v-else>未开通</p>
									</div>
									<a class="sbtn" v-if="item.buy==0" @touchstart.prevent="handlePay(item)">立即开通</a>
								</div>
							</li>
							<!-- <li>
								<div class="listItem">
									<div class="titles" style="width: 100%;" @click="handleClear">
										<p class="title tc">清理邮件</p>
										<p class="red tc">（不可逆）</p>
									</div>
								</div>
							</li> -->
						</ul>
						<div class="more" v-if="goodsList.length > 2 && !isScroll" @touchstart.prevent="scrollBottom"><el-icon><ArrowDownBold /></el-icon></div>
						<div class="more" v-if="goodsList.length > 2 && isScroll" @touchstart.prevent="scrollTop"><el-icon><ArrowUpBold /></el-icon></div>
					</div>
				</div>
				<div class="subConbg">
					<div class="lines">
						<div class="lineItems" @touchstart.prevent="tapDirect($event, handleProps)" @click="tapFallback($event, handleProps)">
							<div class="labels">
								<el-icon class="icon"><Present /></el-icon>
								<span>选择道具</span>
							</div>
							<div class="icons">{{ activeProp.propName || '' }}<el-icon :size="14"><ArrowRightBold /></el-icon></div>
						</div>
						<div class="lineItems" @touchstart.prevent="tapDirect($event, handleNums)" @click="tapFallback($event, handleNums)">
							<div class="labels">
								<el-icon class="icon"><CirclePlus /></el-icon>
								<span>发放数量</span>
							</div>
							<div class="icons">{{ inputNum }}<el-icon :size="14"><ArrowRightBold /></el-icon></div>
						</div>
					</div>
					<div class="btns">
						<div class="btnItems loading" v-if="sendLoading"><el-icon><Loading /></el-icon>道具发放中，请稍后</div>
						<div class="btnItems" v-else @touchstart.prevent="handleCommit">发放道具</div>
					</div>
				</div>
				<div class="closeBtn" @touchstart.prevent="handleClose">
					<el-icon size="30"><Close /></el-icon>
				</div>
			</div>
			<div class="popupCon" :class="{'lans':(!isios && ostype == 2) || (isios && ostype == 1)}" v-else>
				<h2 class="gmTitle">GM权限工具</h2>
				<div class="closeBtn" @touchstart.prevent="handleClose">
					<el-icon size="30"><Close /></el-icon>
				</div>
				<div class="emp">请前往平台激活和使用</div>
			</div>
		</div>
		<Gmdialog v-model:showVisible="showTips" :showHeight="`20rem`" @cancel="handleConfirm">
			<div class="gmsPop">
				<h4 class="title">提示</h4>
				<div class="tips" style="color: #E60E22;">{{ tipMsgs }}</div>
				<div class="btns">
					<div class="btnItems" @touchstart.prevent="handleConfirm">确定</div>
				</div>
			</div>
		</Gmdialog>
		<Gmdialog v-model:showVisible="showRules">
			<div class="gmsPop">
				<h4 class="title">规则说明</h4>
				<div class="txtCon" v-html="formatBr(ruleMsgs)"></div>
			</div>
		</Gmdialog>
		<!-- <Gmdialog :showVisible="showProps" :showHeight="`35rem`" @cancel="cancel"> -->
		<Gmdialog v-model:showVisible="showProps">
			<div class="gmsPop">
				<h4 class="title">选择道具</h4>
				<el-input
				    v-model="searchInput"
				    style="width: 100%;padding: 0 0.5rem;"
				    placeholder="请输入查询的关键词"
					size="large"
					:prefix-icon="Search"
					@input="handleSearchProps"
				    clearable
				  />
				<div class="lines" v-loading="searchLoading">
					<div class="lineItems" v-for="(item,index) in propList" :key="index"
						@touchstart="tapStart" @touchmove.passive="tapMove"
						@touchend="tapEnd($event, handlePropActive, item)"
						@click="tapFallback($event, handlePropActive, item)">
						<div class="labels">
							<span>{{item.propName}} * {{item.num}}</span>
						</div>
						<div class="icons" :class="{'active':activeProp.id == item.id}"></div>
					</div>
				</div>
				<div class="btns">
					<div class="btnItems" @touchstart.prevent="handlePropCommit">确定</div>
				</div>
			</div>
		</Gmdialog>
		<Gmdialog v-model:showVisible="showNums" :showHeight="`31rem`">
			<div class="gmsPop">
				<h4 class="title">发放数量</h4>
				<div class="lines">
					<div class="lineItems" v-for="(item,index) in numsList" :key="index"
						@touchstart="tapStart" @touchmove.passive="tapMove"
						@touchend="tapEnd($event, handleNumActive, item)"
						@click="tapFallback($event, handleNumActive, item)">
						<div class="labels">
							<span>{{ item }}</span>
						</div>
						<div class="icons" :class="{'active':activeNum == item}"></div>
					</div>
					<div class="lineItems" @touchstart.prevent="handleNumActive(oneLimitNum)">
						<div class="labels">
							<el-input @input="handlePropsNum"
							    v-model="inputNum"
							    style="width: 100%;padding: 0 0.5rem;"
							    placeholder="请输入道具发放数量"
								size="small"
							    clearable
							  />
						</div>
						<div class="icons" :class="{'active':activeNum == oneLimitNum}"></div>
					</div>
				</div>
				<div class="btns">
					
					<p style="text-align: center;color: #999;font-size: 12px;">今日可发放道具数量：{{ limitNum }}</p>
					<div class="btnItems" @touchstart.prevent="handleNumCommit">确定</div>
				</div>
			</div>
		</Gmdialog>
	</div>
</template>

<script setup>
	import { getCurrentInstance,onMounted,onBeforeMount,ref,watch,computed, reactive,inject, onBeforeUnmount } from 'vue'
	import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
	import { Search } from '@element-plus/icons-vue'
	import { useRoute,useRouter } from 'vue-router'
	import useIaaStore from '@/store/modules/iaaParams'
	import iaaSdk from '@/utils/iaa_sdk'
	import Gmdialog from '@/views/gmtools/gmdialog'
	import { tapStart, tapMove, tapEnd, tapDirect, tapFallback } from '@/utils/tap'
	
	const { proxy } = getCurrentInstance();
	const router = useRouter();
	const showProps = ref(false)
	const showNums = ref(false)
	const showRules = ref(false)
	const showTips = ref(false)
	const goodsList = ref([])
	const propList = ref([])
	const numsList = ref([1,10,99,999])
	const activeNum = ref(null)
	const activeProp = ref({})
	const activePropInfo = ref({})
	const sendLoading = ref(false)
	const tipMsgs = ref('')
	const ruleMsgs = ref('')
	const errMsg = ref()
	const reload = inject('reload')
	const inputNum = ref(null)
	const searchLoading = ref(false)
	const searchInput = ref('')
	const appVersion = ref('')
	const secretParams = computed(() => {
		return useIaaStore().secretParams
	})
	const isRefresh = computed(() => {
		return useIaaStore().isRefresh
	})
	const ostype = computed(() => {
		return useIaaStore().ostype
	})
	const isOpenPlat = computed(() => {
		return iaaSdk.sdkGmOpenPlat() || false
	})
	const isios = ref(false)
	const limitNum = ref(0)
	const oneLimitNum = ref(99999)//单次发放限制
	const scrollList = ref(null)
	const isScroll = ref(false)
	onMounted(() => {
		device()
		// 检查是否需要强制刷新页面（版本变化）
		checkVersionReload()
		// 强制刷新样式，解决缓存导致的显示问题
		forceStyleRefresh()
		// 获取版本号
		getVersion()

		let query = router.currentRoute.value.query
		if(query && query.isTest){
			useIaaStore().setIsTest(query.isTest)
		}else{
			useIaaStore().setIsTest(0)
		}
		if(query && query.ostype){
			useIaaStore().setOstype(query.ostype)
		}
		if(secretParams.value){
			if(iaaSdk.sdkGmOpenPlat()){
				getInfo()
			}
		}else{
			init()
		}
		if(scrollList.value){
			scrollList.value.addEventListener('scroll',handleScroll);
		}
	})
	onBeforeUnmount(() => {
		if(scrollList.value){
			scrollList.value.removeEventListener('scroll',handleScroll);
		}
	})
	const handleScroll = (e) => {
		const scrollTop = e.target.scrollTop
		const windowHeight = e.target.clientHeight
		const scrollHeight = e.target.scrollHeight
		if(scrollTop > windowHeight){
			isScroll.value = true
		}else{
			isScroll.value = false
		}
	}
	const scrollBottom = () => {
		scrollList.value.scrollTo({
			top: scrollList.value.scrollHeight,
			behavior: 'smooth'
		})
		// scrollList.value.scrollTop = scrollList.value.scrollHeight
	}
	const scrollTop = () => {
		scrollList.value.scrollTo({
			top: 0,
			behavior: 'smooth'
		})
	}
	const handlePropsNum = (val) => {
		if(val > limitNum.value){
			ElMessage({
			    message: '今日可发放道具数量超过限制啦',
			    type: 'error',
				plain: true
			})
		}else if(val > oneLimitNum.value){
			ElMessage({
			    message: `单次最多只能发放${oneLimitNum.value}`,
			    type: 'error',
				plain: true
			})
		}
	}
	const device = () => {
		var u = navigator.userAgent;
		var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
		// var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
		if(isIos){
			isios.value = true
		}else{
			isios.value = false
		}

	}
	// 强制刷新样式，解决WebView缓存导致的样式问题
	const forceStyleRefresh = () => {
		console.log('开始强制刷新样式');

		// 强制触发重排，重新应用样式
		const body = document.body;
		const originalDisplay = body.style.display;
		body.style.display = 'none';
		body.offsetHeight; // 触发重排
		body.style.display = originalDisplay;

		// 检测是否是鸿蒙系统，强制刷新CSS
		const ua = navigator.userAgent;
		const isHarmony = ua.includes('HarmonyOS') || ua.includes('HMS') || ua.includes('OpenHarmony');
		console.log('是否鸿蒙系统:', isHarmony, 'UA:', ua);

		if (isHarmony) {
			// 鸿蒙 WebView 特殊处理：强制重新加载所有样式表
			const styleSheets = document.styleSheets;
			for (let i = 0; i < styleSheets.length; i++) {
				try {
					const sheet = styleSheets[i];
					// 强制重新加载样式表
					const rules = sheet.cssRules || sheet.rules;
					if (rules && rules.length > 0) {
						const cssText = rules[0].cssText;
						sheet.deleteRule(0);
						sheet.insertRule(cssText, 0);
					}
				} catch (e) {
					console.log('样式表操作失败:', e);
					// 跨域样式表无法操作，忽略
				}
			}

			// 鸿蒙系统额外处理：强制重新加载所有 link 标签的 CSS
			setTimeout(() => {
				const links = document.querySelectorAll('link[rel="stylesheet"]');
				links.forEach(link => {
					const href = link.getAttribute('href');
					if (href && !href.includes('?t=')) {
						const newHref = href + '?t=' + new Date().getTime();
						link.setAttribute('href', newHref);
					}
				});
			}, 100);
		}

		// 检查 CSS 是否加载完成
		setTimeout(() => {
			const allLinks = document.querySelectorAll('link[rel="stylesheet"]');
			let loadedCount = 0;
			allLinks.forEach(link => {
				if (link.sheet) {
					loadedCount++;
				} else {
					link.addEventListener('load', () => {
						loadedCount++;
						if (loadedCount === allLinks.length) {
							console.log('所有样式表加载完成');
						}
					});
				}
			});
			console.log('样式表刷新完成，已加载:', loadedCount, '/', allLinks.length);
		}, 200);
	}
	const init = () => {
		iaaSdk.sdkPostMsg({ action: 'webDidLoad' })
	}
	// 获取应用版本号
	const getVersion = () => {
		// 优先从全局变量获取（version.js）
		if (window.APP_VERSION) {
			appVersion.value = window.APP_VERSION;
			console.log('从全局变量获取版本号:', appVersion.value);
			return;
		}

		// 其次从环境变量获取（开发环境）
		if (process.env.APP_VERSION) {
			appVersion.value = process.env.APP_VERSION;
			console.log('从环境变量获取版本号:', appVersion.value);
			return;
		}

		// 再次从 meta 标签获取（生产环境）
		const versionMeta = document.querySelector('meta[name="app-version"]');
		if (versionMeta && versionMeta.content && !versionMeta.content.includes('<%')) {
			appVersion.value = versionMeta.content;
			console.log('从 meta 标签获取版本号:', appVersion.value);
		} else {
			// 开发环境：直接使用 package.json 中的版本号
			// 注意：这里需要与 package.json 中的版本号保持同步
			appVersion.value = '1.1.2'; // 请手动与 package.json version 保持一致
			console.log('使用默认版本号:', appVersion.value);
		}
		console.log('最终版本号:', appVersion.value);
	}
	// 检查版本变化并强制刷新页面
	const checkVersionReload = () => {
		const STORAGE_KEY = 'app_version';
		const FORCE_RELOAD_KEY = 'app_force_reload';
		const currentVersion = appVersion.value || getVersion();
		const storedVersion = localStorage.getItem(STORAGE_KEY);
		const lastReload = localStorage.getItem(FORCE_RELOAD_KEY);

		console.log('检查版本 - 当前:', currentVersion, '存储:', storedVersion);

		// 版本不一致，需要刷新
		if (storedVersion && storedVersion !== currentVersion) {
			console.log('版本变化，准备强制刷新');
			const now = Date.now();

			// 避免短时间内重复刷新（5分钟内只刷新一次）
			if (!lastReload || now - parseInt(lastReload) > 5 * 60 * 1000) {
				localStorage.setItem(STORAGE_KEY, currentVersion);
				localStorage.setItem(FORCE_RELOAD_KEY, now.toString());

				// 清除所有缓存
				if ('caches' in window) {
					caches.keys().then(cacheNames => {
						cacheNames.forEach(cacheName => {
							caches.delete(cacheName);
						});
					});
				}

				// 添加时间戳强制刷新
				const timestamp = new Date().getTime();
				const url = new URL(window.location.href);
				url.searchParams.set('_t', timestamp);

				console.log('执行强制刷新，URL:', url.toString());

				// 短暂延迟后刷新，确保日志输出
				setTimeout(() => {
					window.location.href = url.toString();
					window.location.reload(true);
				}, 100);
			}
		} else if (!storedVersion) {
			// 首次访问，存储版本
			localStorage.setItem(STORAGE_KEY, currentVersion);
		}
	}
	const formatBr = (str) => {
		if(str != null){
		  str = str.replace(/\n/g,'<br/>');
		}
		return str;
	}
	const getInfo = () => {
		iaaSdk.sdkDialogGmInfo((data) => {
			console.log(data)
			goodsList.value = data.gmToolConfigList || []
			ruleMsgs.value = data.describe || ''
			if(goodsList.value.length > 0){
				activePropInfo.value = Object.assign({},goodsList.value[0])
			}
		},(err) => {
			errMsg.value = err.msg
		})
	}
	const getPropNumLimit = () => {
		iaaSdk.sdkGmSendPropNum({ id:activeProp.value.id },(res)=>{
			limitNum.value = res || 0
		},(err)=>{
			console.log(err)
		})
	}
	const handleSearchProps = (val) => {
		searchLoading.value = true
		iaaSdk.sdkGmFindProps(activePropInfo.value.id,{ propName: val },(data) => {
			propList.value = data.gmToolProps
			searchLoading.value = false
		})
	}
	const handleProps = () => {
		// 先弹窗再请求：接口异常/慢的机型上也不能影响弹窗显示
		showProps.value = true
		try{
			iaaSdk.sdkGmGetProps(activePropInfo.value.id,(data) => {
				propList.value = data.gmToolProps
			})
		}catch(e){
			console.log('获取道具列表失败:',e)
		}
	}
	const handleNums = () => {
		console.log('点击=======')
		showNums.value = true
		try{
			if(activeProp.value.id){
				getPropNumLimit()
			}
		}catch(e){
			console.log('获取可发放数量失败:',e)
		}
	}
	const handlePropInfo = (row) => {
		activePropInfo.value = Object.assign({},row)
		activeProp.value = {}
		activeNum.value = null
	}
	const handlePropActive = (row) => {
		activeProp.value = Object.assign({},row)
		getPropNumLimit()
	}
	const handleNumActive = (row) => {
		// 先同步赋值：部分机型/后台状态下 requestAnimationFrame 不回调，只放在帧回调里会导致点了没反应
		activeNum.value = row
		inputNum.value = row
		// 下一帧再赋值一次，保留原有的渲染兜底
		requestAnimationFrame(() => {
		    activeNum.value = row
		    inputNum.value = row
		})
		
		// const screenWidth = window.screen.width;
		// const screenHeight = window.screen.height;
		// console.log('屏幕宽===='+screenWidth)
		// console.log('屏幕高===='+screenHeight)
	}
	const handlePropCommit = () => {
		cancel()
	}
	const handleNumCommit = () => {
		if(inputNum.value > limitNum.value){
			inputNum.value = limitNum.value
		}else if(inputNum.value > oneLimitNum.value){
			inputNum.value = oneLimitNum.value
		}else if(inputNum.value < 0){
			inputNum.value = 0
		}
		cancel()
	}
	const handleClear = () => {
		ElMessage({
		    message: '暂未开放',
		    type: 'error',
			plain: true
		})
	}
	const handlePay = (row) => {
		if(row.buy == 1){
			ElMessage({
			    message: '已经买过了，请勿重复购买',
			    type: 'error',
				plain: true
			})
			return false
		}
		iaaSdk.sdkPostMsg({ action: 'pay_action', data: {
			goodId: row.id,
			goodName: row.title,
			remark: row.id,
			money: row.money
		} })
	}
	const handleCommit = () => {
		if(!activePropInfo.value.id){
			ElMessage({
			    message: '出错了',
			    type: 'error',
				plain: true
			})
			return false
		}
		if(!activeProp.value.id){
			ElMessage({
			    message: '请先选择道具',
			    type: 'error',
				plain: true
			})
			return false
		}
		if(!inputNum.value || inputNum.value <= 0){
			ElMessage({
			    message: '请先选择道具发放数量',
			    type: 'error',
				plain: true
			})
			return false
		}
		if(sendLoading.value){
			ElMessage({
			    message: '请勿频繁操作',
			    type: 'error',
				plain: true
			})
			return false
		}
		sendLoading.value = true
		iaaSdk.sdkGmSendProp({ 
			gmToolId: activePropInfo.value.id, 
			id: activeProp.value.id,
			num: inputNum.value
		},(data) => {//返回提示文案
			tipMsgs.value = data
			showTips.value = true
		},() => {
			sendLoading.value = false
		})
	}
	const handleConfirm = () => {
		sendLoading.value = false
		cancel()
	}
	const handleClose = () => {
		console.log('关闭弹窗')
		useIaaStore().setSecretParams().then(() => {
			iaaSdk.sdkPostMsg({ action: 'close' })
		})
	}
	const cancel = () => {
		showProps.value = false
		showNums.value = false
		showRules.value = false
		showTips.value = false
	}
	watch(secretParams, (newVal,oldVal) => {
		if(newVal){
			if(iaaSdk.sdkGmOpenPlat()){
				getInfo()
			}
		}
	},{ deep:true })
	watch(isRefresh, (newVal,oldVal) => {
		let nowPageName = router.currentRoute.value.name
		if(newVal && newVal == nowPageName){
			console.log('刷新执行:'+newVal)
			useIaaStore().setRefresh('')
			reload()
		}
	},{ deep:true })
</script>

<style lang="less" scoped>
	@width: 90vw;@height: 34rem;
	@maxWidth: 45rem;
	@space: 1rem;
	.tc{
		text-align: center;
	}
	@keyframes scrolls{
		0%,100%{ bottom: 0.25rem;}
		50%{ bottom: 0;}
	}
	.popupBox{
		width: 100%;height: 100vh;max-width: @maxWidth;margin: 0 auto;position: relative;overflow: hidden;
		.versionInfo{
			position: fixed;
			right: 1rem;
			bottom: 1rem;
			color: rgba(255, 255, 255, 0.5);
			font-size: 0.8rem;
			z-index: 10;
			pointer-events: none;
			user-select: none;
		}
		.popupCon{
			width: @width;
			max-height: @height;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			-webkit-transform: translate(-50%, -50%);
			background: #439DFF;border-radius: 2rem;padding: 1rem 1.2rem 1.8rem;box-sizing: border-box;
			.emp{
				background: #fff;color: #222;text-align: center;line-height: 5rem;font-size: 1.875rem;
				padding: 1.25rem 0;font-weight: 500;border-radius: 0.625rem;
			}
			&.lans{//横屏
				width: 80vh;
				.closeBtn{
					right: calc((100% - 80vh) / 2 + 1rem);
				}
			}
			.closeBtn{
				position: absolute;width: 3rem;height: 3rem;color: #fff;
				right: calc((100% - @width) / 2 + 1rem);top: 1rem;
			}
			.gmTitle{
				font-size: 1.8rem;text-align: center;line-height: 3rem;margin: 0 0 @space;color: #fff;
			}
			.subConbg{
				background: #fff;padding: 0.8rem 0 1.2rem;border-radius: 0.8rem;margin-top: 1.2rem;position: relative;
				.more{
					position: absolute;bottom: 0.25rem;left: 50%;transform: translate(-50%,0);
					animation: scrolls 1s linear infinite;padding: 0 0.625rem;
				}
			}
			.gmList{
				padding-bottom: 1.625rem;
				.subTitle{
					font-size: 1.4rem;padding-left: @space;padding-right: @space;
					margin: 0.5rem 0;width: 100%;box-sizing: border-box;
					display: inline-flex;align-items: center;justify-content: space-between;
				}
				.listCon{
					width: 100%;height: 5.5rem;overflow-y: scroll;
					
				}
				ul{
					-webkit-display: flex;display: flex;
					-webkit-align-items: flex-start;align-items: flex-start;
					-webkit-flex-wrap: wrap;flex-wrap: wrap;
					padding: 0 @space;box-sizing: border-box;
					li{
						width: calc(50% - @space / 2);box-sizing: border-box;display: block;
						margin-top: calc(@space / 2);margin-bottom: calc(@space / 2);
						.listItem{
							width: 100%;height: 5rem;background: #F1F1F1;
							border-radius: 1rem;padding: 0.3rem 0.8rem;box-sizing: border-box;
							display: flex;align-items: center;justify-content: space-between;
							&.active{
								box-shadow: inset 0 0 0.5rem 0.2rem #439DFF;
							}
							.titles{
								width: calc(100% - 5rem);
							}
							.title{
								color: #505050;font-size: 1.3rem;font-weight: 500;
								white-space: nowrap;overflow: hidden;text-overflow: ellipsis;
								width: 100%;
							}
							.red{
								color: red;
							}
							.green{
								color: green;
							}
							.sbtn{
								display: inline-block;width: 5rem;height: 2rem;line-height: 2rem;text-align: center;
								background: linear-gradient(to right,#F06A38,#E60E22);color: #fff;border-radius: 1rem;
								font-size: 0.9rem;flex-shrink: 0;
							}
						}
						&:nth-child(2n){
							margin-left: @space;
						}
					}
				}
			}
			.lines,.btns{
				padding: 0 @space;margin: 0;
			}
			.lineItems{
				-webkit-display: flex;display: flex;
				-webkit-justify-content: space-between;justify-content: space-between;
				height: 4rem;border-bottom: 1px solid #F9FBFA;
				.labels,.icons{
					-webkit-display: flex;display: flex;
					-webkit-align-items: center;align-items: center;
					-webkit-justify-content: flex-end;justify-content: flex-end;
				}
				.labels{
					font-size: 1.3rem;color: #3E3E3E;font-weight: 500;
					.icon{
						font-size: 1.3rem;margin-right: 0.2rem;
					}
				}
				.icons{
					height: 100%;align-items: center;color: #CDCFCE;font-size: 1.4rem;flex: 1;
				}
			}
			.btns{
				margin-top: 1.2rem;
				.btnItems{
					width: 100%;height: 4rem;line-height: 4rem;text-align: center;
					background: linear-gradient(to right,#439DFF,#746FFF);border-radius: 2rem;font-size: 1.3rem;
					color: #fff;
					&.loading{
						display: flex;align-items: center;justify-content: center;opacity: 0.6;
						i{
							margin-right: 0.3125rem;
							animation: 2s linear 0s infinite normal none running rotating;
						}
					}
				}
			}
			
		}
	}
	.gmsPop{
		height: 100%;
		h4.title{
			text-align: center;font-size: 1.6rem;margin-bottom: 1.2rem;
		}
		/deep/.el-input__wrapper{
			border-radius: 2rem;
		}
		.lines,.btns{
			width: 100%;padding: 0 0.5rem;margin: 0.5rem 0;box-sizing: border-box;
		}
		.lines{
			height: 18.5rem;
			overflow-y: auto;
			  -webkit-overflow-scrolling: touch;
			  touch-action: pan-y;
		}
		.tips{
			height: 42%;
			overflow-y: auto;
			  -webkit-overflow-scrolling: touch;
			  touch-action: pan-y;
			text-align: center;margin-top: 10%;
		}
		.txtCon{
			height: 88%;
			overflow-y: auto;
			  -webkit-overflow-scrolling: touch;
			  touch-action: pan-y;
			background: #eee;border-radius: 0.5rem;
			padding: 0.5rem 0.8rem;box-sizing: border-box;font-size: 1.2rem;
		}
		.lineItems{
			display: flex;justify-content: space-between;height: 3.6rem;border-bottom: 1px solid #F9FBFA;
			align-items: center;cursor: pointer;-webkit-tap-highlight-color: transparent;user-select: none;
			.labels,.icons{
				display: flex;align-items: center;justify-content: flex-end;
			}
			.labels{
				font-size: 1.3rem;
			}
			.icons{
				width: 1.2rem;height: 1.2rem;border: 0.2rem solid #EAEBEC;border-radius: 100%;
				&.active{
					border: 2px solid #439DFF;position: relative;
					&::after{
						content: '';width: 0.6rem;height: 0.6rem;border-radius: 100%;background: #439DFF;
						position: absolute;left: 0.3rem;top: 0.3rem;
					}
				}
			}
		}
		.btns{
			margin-top: 1.2rem;
			.btnItems{
				width: 100%;height: 4rem;line-height: 4rem;text-align: center;
				background: linear-gradient(to right,#439DFF,#746FFF);border-radius: 2rem;font-size: 1.3rem;
				color: #fff;
			}
		}
	}
	
	@media all and (orientation : landscape) and (min-width: 600px) and (min-height: 600px){
		@width: 35rem;
		.popupBox .popupCon{
			width: @width !important;
			.closeBtn{
				right: calc((100% - @width) / 2 + 1rem) !important;
			}
		}
	}
	@media all and (orientation : landscape) and (min-width: 600px) and (max-height: 450px){
		@width: 80vh;
		.popupBox .popupCon{
			width: @width;
			.closeBtn{
				right: calc((100% - @width) / 2 + 1rem);
			}
		}
	}
	@media all and (orientation : portrait) and (min-width: 600px) and (min-height: 600px){
		@width: 35rem;
		.popupBox .popupCon{
			width: @width;
			.closeBtn{
				right: calc((100% - @width) / 2 + 1rem);
			}
		}
	}
</style>